function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMindfitTextWhite = function SvgMindfitTextWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.271,
    height: 17
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.09 193.57c0-21.2-.4-38.5-1.7-55.5h32.6l1.7 33h1.3c11.4-19.5 30.5-37.7 64.3-37.7 27.9 0 49.1 16.9 58 41.1h.8c6.4-11.4 14.4-20.3 22.9-26.7 12.3-9.3 25.8-14.4 45.3-14.4 27.1 0 67.3 17.8 67.3 88.9v120.6h-36.4v-116c0-39.4-14.4-63.1-44.4-63.1-21.2 0-37.7 15.7-44 33.9-1.7 5.1-3 11.9-3 18.6v126.6h-36.4v-122.6c0-32.6-14.4-56.3-42.8-56.3-23.3 0-40.2 18.6-46.1 37.3-2.1 5.5-3 11.9-3 18.2v123.6h-36.4zm394.5-113c.4 12.7-8.9 22.9-23.7 22.9-13.1 0-22.4-10.2-22.4-22.9s9.7-23.3 23.3-23.3c13.9 0 22.8 10.1 22.8 23.3zm-41.5 262.4v-204.9h37.3v204.9zm99.1-149.4c0-21.2-.4-38.5-1.7-55.5h33l2.1 33.9h.8c10.2-19.5 33.9-38.5 67.7-38.5 28.4 0 72.4 16.9 72.4 87.2v122.3h-37.3v-118.1c0-33-12.3-60.5-47.4-60.5-24.6 0-43.6 17.4-50 38.1-1.7 4.7-2.5 11-2.5 17.4v123.2h-37.3v-149.5zm411.9-151.1v247.6c0 18.2.4 38.9 1.7 52.9h-33.4l-1.7-35.6h-.8c-11.4 22.9-36.4 40.2-69.8 40.2-49.5 0-87.6-41.9-87.6-104.1-.4-68.2 41.9-110.1 91.9-110.1 31.3 0 52.5 14.8 61.8 31.3h.8V42.47Zm-37.3 179c0-4.7-.4-11-1.7-15.7-5.5-23.7-25.8-43.2-53.8-43.2-38.5 0-61.4 33.9-61.4 79.2 0 41.5 20.3 75.8 60.5 75.8 25 0 47.8-16.5 54.6-44.4 1.3-5.1 1.7-10.2 1.7-16.1v-35.6z",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: 10,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeOpacity: 1
    },
    transform: "translate(-27.902 -2.008)scale(.05387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.09 347.67v-179.2h-29.2v-28.8h29.2v-11.2c0-55 32.2-90.7 90.7-90.7 19.3 0 42.1 6 52.9 13.8l-10.7 28.8c-9-6.4-25.4-12-43.8-12-40 0-51.6 27.9-51.6 61v10.3h120.8v208h-37.4v-179.2h-83.4v179.2zm266.5-267.8v59.7h54.2v28.8h-54.2v112.2c0 25.8 7.3 40.4 28.4 40.4 9.9 0 17.2-1.3 21.9-2.6l1.7 28.4c-7.3 3-18.9 5.2-33.5 5.2-17.6 0-31.8-5.6-40.8-15.9-10.7-11.2-14.6-29.7-14.6-54.2v-113.4h-32.2v-28.8h32.2v-49.9zm86.4 245.4c0-15.9 10.7-27.1 25.8-27.1s25.4 11.2 25.4 27.1-9.9 27.1-25.8 27.1-25.4-11.6-25.4-27.1z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeOpacity: 1
    },
    transform: "translate(-27.902 -2.008)scale(.05387)"
  })));
};
export default SvgMindfitTextWhite;